/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
  document.addEventListener('variant:added', function (event) {
  if (!event?.detail) return;

    const detail = event && event.detail ? event.detail : {};
    const src = detail.src;
    const cart = detail.cart;
    const cartVariant = detail.variant;
    let cartData = {};

    // Klaviyo created variables
    let addedItem = window.item;
    let klaviyo = window.klaviyo || [];

    // Update Klaviyo created item price. Klaviyo injected snippet uses product
    // price which may not be the actual price of the added varaint.
    if (addedItem && cartVariant) {
      addedItem.Price = window.RS.helpers.formatMoney(cartVariant.price);
    }

    // If not on the pdp or is the main product form on the pdp and the Klaviyo
    // item object does not exist, mimic Klaviyo item object as best as possible.
    // Some properties are not available from JS Shopify object.
    if (src !== 'pdp' || (src === 'pdp' && !addedItem)) {
      if (cartVariant) {
        addedItem = {
          Brand: cartVariant.vendor,
          ImageURL: cartVariant.image,
          Name: cartVariant.product_title,
          Price: window.RS.helpers.formatMoney(cartVariant.price),
          ProductID: cartVariant.product_id,
          URL: `${window.themeVariables.routes.secureShopUrl}${cartVariant.url}`
        }
      }
    }

    if (addedItem) {
      addedItem.src = src;
    }

    if (cart) {
      // Format from Klaviyo docs:
      // https://help.klaviyo.com/hc/en-us/articles/115001396711-Guide-to-Creating-an-Added-to-Cart-Event-for-Shopify
      cartData = {
        total_price: cart.total_price / 100,
        $value: cart.total_price / 100,
        total_discount: cart.total_discount,
        original_total_price: cart.original_total_price / 100,
        items: cart.items
      }
    }

    klaviyo.push([
      'track',
      'Added to Cart',
      {
        ...(addedItem || {}),
        ...cartData
      }
    ])
  });

/*
 * Custom Okendo Widget Scroll-to and Tab-Activate Logic
 * HMG Final Script for Reviews & Q&A links
 */
document.addEventListener('DOMContentLoaded', function () {
  function activateOkendoTab(tabType) {
    const widget = document.querySelector('.oke-w');
    if (!widget) return;

    const tabSelector = tabType === 'questions'
      ? 'button[id^="questions-tab-"]'
      : 'button[id^="reviews-tab-"]';
    const tabButton = widget.querySelector(tabSelector);

    if (tabButton) {
      tabButton.click();
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initOkendoLinks() {
    const reviewsLink = document.querySelector('.hmg-okendo-reviews-link');
    const qaLink = document.querySelector('.hmg-okendo-qa-link');

    if (reviewsLink && !reviewsLink.dataset.hmgInit) {
      reviewsLink.dataset.hmgInit = 'true';
      reviewsLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        activateOkendoTab('reviews');
      });
    }

    if (qaLink && !qaLink.dataset.hmgInit) {
      qaLink.dataset.hmgInit = 'true';
      qaLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        activateOkendoTab('questions');
      });
    }

    return reviewsLink && qaLink;
  }

  const poll = setInterval(() => {
    if (initOkendoLinks()) {
      clearInterval(poll);
    }
  }, 300);

  setTimeout(() => clearInterval(poll), 10000);
});

// HMG — Build & reveal the bracketed count in one go
document.addEventListener("DOMContentLoaded", function() {
  const outerWidget    = document.querySelector(".hmg-final-okendo-widget");
  const countContainer = document.querySelector(".oke-sr-count--brackets");
  if (!outerWidget || !countContainer) return;

  // Hide until built
  countContainer.style.visibility = "hidden";

  // Remove any stray direct children of the widget
  outerWidget.querySelectorAll(":scope > a, :scope > span").forEach(el => el.remove());

  // Grab the raw number
  const rawCount = countContainer.querySelector(".oke-sr-count-number")?.textContent.trim();
  if (!rawCount) return;

  // Clear old content
  countContainer.innerHTML = "";

  // Build the Reviews link
  const reviewsLink = document.createElement("a");
  reviewsLink.href = "#";
  reviewsLink.dataset.okeScrollTo = "reviews";
  reviewsLink.className = "hmg-okendo-reviews-link";
  reviewsLink.textContent = `${rawCount} Reviews`;
  reviewsLink.style.cursor = "pointer";
  reviewsLink.addEventListener("click", e => {
    e.preventDefault();
    document.querySelector('button[id^="reviews-tab-"]')?.click();
    document.querySelector(".oke-w")?.scrollIntoView({ behavior: "smooth" });
  });

  // Separator
  const sep = document.createElement("span");
  sep.textContent = "|";
  sep.style.margin = "0 4px";

  // Build the Q&A link
  const qaLink = document.createElement("a");
  qaLink.href = "#";
  qaLink.dataset.okeScrollTo = "questions";
  qaLink.className = "hmg-okendo-qa-link";
  qaLink.textContent = "Q&A";
  qaLink.style.cursor = "pointer";
  qaLink.addEventListener("click", e => {
    e.preventDefault();
    document.querySelector('button[id^="questions-tab-"]')?.click();
    document.querySelector(".oke-w")?.scrollIntoView({ behavior: "smooth" });
  });

  // Append in order: [Reviews] [|] [Q&A]
  countContainer.append(reviewsLink, sep, qaLink);

  // Reveal it
  countContainer.style.visibility = "visible";
});

})();